import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'components/Feedback';
import { Button, MultipleSelect, TextField } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';

export const ModalDuplicate = props => {
  const { onClose, onValidate, domains = [] } = props;

  const [name, setName] = useState();
  const [selectedDomains, setSelectedDomains] = useState([]);

  const handleValidate = () => {
    onValidate({ name, domains: selectedDomains });
  };

  const updateSelectedDomains = data => {
    setSelectedDomains(data.map(el => el.key));
  };

  return (
    <Modal titleHead="Dupliquer la configuration" maxWidth="xs" {...props}>
      <Container>
        <Row>
          <TextField
            value={name}
            onChange={setName}
            required
            title="Nom de la configuration"
          />
          <Item style={{ paddingTop: '10px' }} />
          <MultipleSelect
            title="Domaines"
            options={domains}
            selected={selectedDomains}
            onChange={updateSelectedDomains}
          />
        </Row>
        <Row>
          <Item xs={12} sm={6} padding="0px">
            <Button
              variant="outlined"
              size="medium"
              widthSize="medium"
              rounded
              onClick={onClose}
            >
              Annuler
            </Button>
          </Item>
          <Item xs={12} sm={6} padding="0px">
            <Button
              variant="outlined"
              size="medium"
              widthSize="medium"
              rounded
              onClick={handleValidate}
            >
              Confirmer
            </Button>
          </Item>
        </Row>
      </Container>
    </Modal>
  );
};

ModalDuplicate.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  domains: PropTypes.arrayOf(PropTypes.any).isRequired
};

export default ModalDuplicate;
